// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.go-to-report-button{margin-top:11px;margin-left:-12px;height:40px !important;width:40px !important}`, "",{"version":3,"sources":["webpack://./packages/builder-manager/franchise-monthly-report/components/franchise-report-filter/franchise-report-filter.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAOA,qBACE,eAAA,CACA,iBAAA,CACA,sBAAA,CACA,qBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n.go-to-report-button {\n  margin-top: 11px;\n  margin-left: -12px;\n  height: 40px !important;\n  width: 40px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
